import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    height: auto;
    margin: 0 auto;

    .loader {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 50%;
        margin-top: 200px;
        transform: translateX(-50%);
    }

    @media (max-width: 1000px) {
        min-width: 1200px;
    }
`;

export const Menu = styled.div`
    display: flex;
    justify-content: space-between;    
    /* max-width: 1040px; */
`

export const Filter = styled.div`
    display: flex ;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    height: fit-content;
    margin: 16px 0;
    /* max-width: 1040px; */

    .results {
        align-self: flex-start;
        font-size: 16px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.interfaceText400};
    }

    .buttons {
        align-self: flex-end;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        position: relative;

        .countie-selector {
            display: flex;
            align-items: center;
            gap: 10px;

            .filters {
                width: 250px;
            }
        }

        .countie {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            min-width: 120px;
            height: 32px;
            padding: 10px;
            background: ${({ theme }) => theme.colors.interfacePure100};
            border-radius: 8px;
            color: ${({ theme }) => theme.colors.default};
            font-size: 14px;
            cursor: pointer;            

            .countie-selected {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                gap: 8px;
                width: max-content;
                height: 32px;
                border-radius: 8px;
                padding: 5px 20px;
                background: ${({ theme }) => theme.colors.interfaceGray300};
                color: ${({ theme }) => theme.colors.interfacePure0};
                margin-left: 10px;
                .close-icon {
                    width: 24px;
                    svg {
                        path {
                            fill: ${({ theme }) => theme.colors.interfacePure0};
                        }
                    }
                }
            }
        }

        .plan {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            min-width: 110px;
            height: 32px;
            background: ${({ theme }) => theme.colors.interfacePure100};
            border-radius: 8px;
            padding: 10px;
            color: ${({ theme }) => theme.colors.interfaceTextGray};
            font-size: 14px;
            cursor: pointer;
            svg {
                path {
                    fill: ${({ theme }) => theme.colors.interfaceTextGray};
                }
            }

            .plan-map {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                gap: 20px;
                width: 344px;
                height: 180px;
                border-radius: 8px;
                padding: 24px;
                background: ${({ theme }) => theme.colors.interfacePure0};
                cursor: default;
                filter: drop-shadow(3px 4px 7px rgba(20, 20, 23, 0.3));
                position: absolute;
                top: 40px;
                right: 0;
                z-index: 99;
                overflow-y: auto;
                &.no-show {
                    display: none;
                }

                .filters {
                    display: flex;
                    align-items: center;
                    padding-left: 16px;
                    width: 100%;
                    height: 52px;
                    border-radius: 8px;
                    color: ${({ theme }) => theme.colors.interfaceText400};
                    font-size: 16px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all .2s;
                    &:hover {
                        background: ${({ theme }) => theme.colors.interfaceText100};
                    }
                }
            }

        }

        .plan-selected {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            /* position: absolute;
            top: 0;
            right: 0;
            width: max-content; */
            height: 32px;
            border-radius: 8px;
            padding: 5px 20px;
            background: ${({ theme }) => theme.colors.interfaceGray300};
            color: ${({ theme }) => theme.colors.interfacePure0};
            .close-icon {
                width: 24px;
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.interfacePure0};
                    }
                }
            }
        }

        
        .date-map {
            display: flex;
            flex-direction: column;
            width: 344px;
            height: 185px;
            border-radius: 8px;
            padding: 24px;
            background: ${({ theme }) => theme.colors.interfacePure0};
            cursor: default;
            filter: drop-shadow(3px 4px 7px rgba(20, 20, 23, 0.3));
            position: absolute;
            top: 0;
            right: 0;
            z-index: 99;
            &.no-show {
                display: none;
            }

            .select-date {
                display: flex;
                justify-content: space-between;
                gap: 16px;

                .start-date {
                    width: 144px;     
                    
                    .date-field {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 48px;
                        border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
                        border-radius: 8px;
                        padding: 12px;
                        font-size: 16px;
                        margin-top: 8px;
                        margin-bottom: 16px;

                        .react-date-picker__wrapper {
                            display: flex;
                            flex-grow: 1;
                            flex-shrink: 0;
                            /* border: thin solid gray; */
                        }

                        input {
                            width: 100%;
                            border: none;
                            outline: none;
                            text-align: center;
                            color: ${({ theme }) => theme.colors.interfaceText400};
                        }
                    }
                }
            }

            .filters {
                display: flex;
                align-items: center;
                width: 100%;
                height: 16px;
                border-radius: 8px;
                color: ${({ theme }) => theme.colors.interfaceText400};
                font-size: 16px;
                font-weight: 500;                   
            }
        }
            
        .selected-data {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            position: relative;
            height: 32px;
            border-radius: 8px;
            padding: 5px 20px;
            background: ${({ theme }) => theme.colors.interfaceGray300};
            color: ${({ theme }) => theme.colors.interfacePure0};
            font-size: 14px;
            .close-icon {
                width: 24px;
                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.interfacePure0};
                    }
                }
            }
        }
    }
`

export const Paginate = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 24px;
    position: absolute;
    bottom: 0;
    left: -10px;
    margin-bottom: -50px;
    padding-bottom: 20px;

    .pagination {
        display: flex;
        gap: 8px;
        list-style-type: none;
        .page-link {
            display: flex;
            align-items: center;
            justify-content: center;            
            width: 24px;
            height: 24px;
            background: transparent;
            border: 1px solid ${({ theme }) => theme.colors.interfaceText200};
            font-weight: 500;
            color: ${({ theme }) => theme.colors.interfaceText400};
            transition: all .2s;
            font-size: 12px;
            font-weight: 500;
            cursor: pointer;
            &:hover {
                color: ${({ theme }) => theme.colors.interfaceGray400};
                border: 1px solid ${({ theme }) => theme.colors.interfaceGray400};
            }
            &.active {
                display: flex;
                align-items: center;
                justify-content: center;            
                width: 24px;
                height: 24px;
                color: ${({ theme }) => theme.colors.interfaceGray400};
                border: 1px solid ${({ theme }) => theme.colors.interfaceGray400};
            }
        }
        .page-item {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            color: ${({ theme }) => theme.colors.interfaceGray400};
        }
        .back-page,
        .next-page {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border: 1px solid ${({ theme }) => theme.colors.interfaceText200};
            cursor: pointer;
            &:hover {
                color: ${({ theme }) => theme.colors.interfaceGray400};
                border: 1px solid ${({ theme }) => theme.colors.interfaceGray400};
            }
            &.active {
                color: ${({ theme }) => theme.colors.interfaceGray400};
                border: 1px solid ${({ theme }) => theme.colors.interfaceGray400};
            }
        }

        .back-link-page,
        .next-link-page {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
        }

    }
`